import { Drawer, styled } from "@mui/material";
import { FilterLiveForm } from "ra-core";
import type * as React from "react";

export const asideWidth = 260;

const Form = styled("form")({ width: asideWidth });

export const FilterAside = ({ open, onOpen, children, isSmall }: FilterAsideProps): JSX.Element => {
    return isSmall ? (
        <Drawer
            variant="temporary"
            open={open}
            onClose={() => onOpen(!open)}
            anchor="right"
            sx={_ => ({
                width: asideWidth,
            })}
        >
            <FilterLiveForm formComponent={Form}>{children}</FilterLiveForm>
        </Drawer>
    ) : (
        <Drawer
            sx={_ => ({
                width: asideWidth,
                flexShrink: 0,
                "& .MuiPaper-elevation": {
                    padding: 0,
                },
                "& .MuiPaper-root": {
                    position: "relative",
                },
            })}
            variant="persistent"
            anchor="right"
            open={open}
        >
            <FilterLiveForm formComponent={Form}>{children}</FilterLiveForm>
        </Drawer>
    );
};

interface FilterAsideProps {
    open: boolean;
    onOpen: (x: boolean) => void;
    isSmall: boolean;
    children: React.ReactElement[];
}
